// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

// Types
import { Theme } from '../../types/theme';

// Components
import {
  Paragraph,
  ParagraphAlign,
  ParagraphSize,
  ParagraphWeight,
} from '../../layout/elements/Paragraph';
import {
  Title,
  TitleSize,
} from '../../layout/elements/Title';

// Icons
import { RotatePhone } from '../../layout/icons';

// Style
import {
  IconContainer,
  OverlayContainer,
} from './RotateDeviceOverlay.style';

// Types
import { RotateDeviceOverlayProps } from './RotateDeviceOverlay.types';

function RotateDeviceOverlay({
  className,
  testId,
}: RotateDeviceOverlayProps): JSX.Element {
  const { t } = useTranslation();
  const theme: Theme = useTheme();

  return (
    <OverlayContainer className={className} data-testid={testId}>
      <IconContainer data-testid="rotate-icon">
        <RotatePhone />
      </IconContainer>
      <Title
        size={TitleSize.xxs}
        color={theme.color.rotateDeviceOverlay.titleColor}
      >
        {t('view.crusher.trendings.rotateDevice.title')}
      </Title>
      <Paragraph
        size={ParagraphSize.sm}
        weight={ParagraphWeight.regular}
        align={ParagraphAlign.center}
        color={theme.color.rotateDeviceOverlay.descriptionColor}
      >
        {t('view.crusher.trendings.rotateDevice.description')}
      </Paragraph>
    </OverlayContainer>
  );
}

export { RotateDeviceOverlay };
